import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/opt/build/repo/src/components/default-layout-narrow.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`Contact`}</h1>
    <p>{`Join our `}<a parentName="p" {...{
        "href": "https://join.slack.com/t/tattle-workspace/shared_invite/zt-da07n75v-kIw9Z5b~_gDKP~JsScP1Vg"
      }}>{`slack channel`}</a>{` for regular updates on the project.`}</p>
    <p>{`Head over to `}<a parentName="p" {...{
        "href": "https://github.com/tattle-made"
      }}>{`Github`}</a>{` if you’d like to contribute to the code base.`}</p>
    <p>{`You can also join our shared research library on `}<a parentName="p" {...{
        "href": "https://tarunima.typeform.com/to/Z2mUul"
      }}>{`Zotero`}</a>{`.`}</p>
    <p>{`Or email us on `}<a parentName="p" {...{
        "href": "mailto:admin@tattle.co.in"
      }}>{`admin@tattle.co.in`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      